import React from 'react'
import { type IconsProps, useConfig } from 'msp-integrations'
import { getAssetUrl } from 'pwa-kit-react-sdk/ssr/universal/utils'
import NoIcon from './NoIcon'

export const SvgSizeMatrix: { [key: string]: string } = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '30px'
}

const Icons = ({
  color,
  stroke,
  height,
  size = 'sm',
  width,
  iconName,
  asFile
}: IconsProps) => {
  const {
    theme: { iconMapping }
  } = useConfig()
  const fallbackSize = {
    height: SvgSizeMatrix[size],
    width: SvgSizeMatrix[size]
  }
  if (asFile) {
    const img = getAssetUrl(`static/svg/${iconName}.svg`)
    return (<img
      src={img}
      alt={iconName}
      {...(height && { height: height })}
      {...(width && { width: width })}
      {...(!height && !width && fallbackSize)}
      loading='lazy' />)
  }
  else {
    const Icon = (iconMapping?.[iconName] ?? iconMapping?.['Close']) || NoIcon

    return (
      Icon && (
        <Icon
          fill={color ? String(color) : 'inherit'}
          stroke={stroke ? String(stroke) : 'inherit'}
          strokeWidth={stroke ? '8px' : 'inherit'}
          {...(height && { height: height })}
          {...(width && { width: width })}
          {...(!height && !width && fallbackSize)}
        />
      )
    )
  }
}

export default Icons
